import React from 'react';
import classNames from 'clsx';

import { BrandAmbassadorEnum } from 'app/shared/enums';
import { BrandAmbassadorRecommendationProps } from './BrandAmbassadorRecommendation.interface';
import { useStyles } from './BrandAmbassadorRecommendation.styles';

export default function BrandAmbassadorRecommendation({
  className,
}: BrandAmbassadorRecommendationProps) {
  const classes = useStyles();

  return (
    <div
      className={classNames(classes.root, className)}
      data-cy={'brand-ambassador-recommendation'}
    >
      <div className={classes.title}>
        {BrandAmbassadorEnum.BrandAmbassadorTitle}
      </div>
      <div className={classes.desc}>
        {BrandAmbassadorEnum.BrandAmbassadorDesc}
      </div>
    </div>
  );
}
